import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { Button } from 'reactstrap';
import { trackMixpanelPageView } from 'helpers/post';
import { withQueryParamCapture } from '@helpers/useQueryParamCapture';
import { clearFunnelStart } from '@helpers/localStorage';
import BasicOptionCard from '../OptionCards/BasicOptionCard';
import { SegmentedStepper } from '@dev-go4ellis/go4-design-system';
import { getFunnelStepperConfig } from '../funnelSteps';
import './UserRole.scss';

const EVENT_OPERATOR = 'EventOperator';
const ATHLETIC_TRAINER = 'AthleticTrainer';

// Mixpanel event ids for path selection tracking.
const ROLE_SELECT_EVENT_ID = {
  [EVENT_OPERATOR]: 'RoleSelectJP',
  [ATHLETIC_TRAINER]: 'RoleSelectAT',
};

const USER_ROLE_OPTIONS = [
  { title: 'Hire an Athletic Trainer', value: EVENT_OPERATOR },
  { title: 'Find Work', value: ATHLETIC_TRAINER },
];

class UserRole extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedRole: null,
    };
  }

  componentDidMount() {
    trackMixpanelPageView('/create-account/role');
    localStorage.removeItem('registrationOrgType');
    clearFunnelStart();
  }

  onSelect = value => e => {
    e.preventDefault();
    e.currentTarget.blur();
    this.setState({ selectedRole: value });
    // Fire path-selection event so we can measure drop-off between the two
    // branches in the first funnel step.
    const eventId = ROLE_SELECT_EVENT_ID[value];
    if (eventId) trackMixpanelPageView(eventId);
  };

  onContinue = () => {
    const { selectedRole } = this.state;
    if (selectedRole === ATHLETIC_TRAINER) {
      this.props.history.push('/create-account/athletic-trainer-sign-up');
    } else if (selectedRole === EVENT_OPERATOR) {
      this.props.history.push('/create-account/organization-type');
    }
  };

  trackLogin = () => {
    trackMixpanelPageView('IntroLogInClick');
  };

  render() {
    const { selectedRole } = this.state;
    const buttonDisabled = !selectedRole;
    const funnelStepper = getFunnelStepperConfig('/create-account/role');

    return (
      <div className="v3-user-role">
        <main>
          {funnelStepper && (
            <div className="mobile-stepper">
              <SegmentedStepper total={funnelStepper.total} current={funnelStepper.current} size="sm" />
            </div>
          )}
          <header>
            <div className="screen-title gotham-bold-font">What can we help you with?</div>
          </header>
          <div className="content">
            <div className="role-options">
              {USER_ROLE_OPTIONS.map(({ title, value }) => (
                <BasicOptionCard
                  key={value}
                  title={title}
                  onClick={this.onSelect(value)}
                  selected={selectedRole === value}
                  padding="lg"
                  fontSize="18px"
                />
              ))}
            </div>
          </div>
        </main>
        <div className="navigation-buttons">
          <div className="nav-login-container">
            <div className="nav-login-text">Already have an account?</div>
            <Link to="/" onClick={this.trackLogin} className="login-btn gotham-medium-font">
              <div>Log In</div>
            </Link>
          </div>
          <Button onClick={this.onContinue} className="continue-button" disabled={buttonDisabled}>
            <div>Continue &#8594;</div>
          </Button>
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  authenticated: state.session.authenticated,
  user: state.session.currentUser,
});

export default withQueryParamCapture(connect(mapStateToProps)(UserRole));